import { schema } from 'normalizr';
import {
	RULESET_SCHEMA_NAME,
	BLUEPRINTS_SCHEMA_NAME,
	PROJECT_RUN_AS_USER_SCHEMA_NAME,
} from './constants';

const blueprintSchema = new schema.Entity(
	BLUEPRINTS_SCHEMA_NAME,
	{},
	{
		idAttribute: 'moduleKey',
	},
);

const ruleSetSchema = new schema.Entity(RULESET_SCHEMA_NAME);

const projectRunAsUserSettingsSchema = new schema.Object({});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default {
	[PROJECT_RUN_AS_USER_SCHEMA_NAME]: projectRunAsUserSettingsSchema,
	[RULESET_SCHEMA_NAME]: [ruleSetSchema],
	[BLUEPRINTS_SCHEMA_NAME]: [blueprintSchema],
};
